/** @jsxImportSource @emotion/react */
import React, { ReactElement } from 'react'
import * as classes from './styles'

export type HeaderWrapperProps = {
  children: ReactElement | ReactElement[]
  className?: string
}

export const HeaderWrapper = ({ children, ...rest }: HeaderWrapperProps) => (
  <div css={classes.headerWrapper} {...rest}>
    {children}
  </div>
)
